export type Done = {
  type: 'DONE';
};

export const done: Done = {
  type: 'DONE',
};

export type PageNumber = number | Done;
